export default "__VITE_ASSET__CQjNlQxs__"